module.exports = __webpack_public_path__ + "static/img/iconOne.73dcf683.svg";